import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../utils/UtilsUrl";

// const BASE_BK_URL = "http://localhost:8082/gateway/finance/Banque"
// const BASE_BK_URL = "http://192.168.1.112:8082/gateway/finance/Banque"

class ManufacturingBatchService {
  addManufacturingBatche(model) {
    return api.post(
      UtilsUrl.ManufacturingBatchURL() + "/addManufacturingBatche",
      model
    );
  }
  deleteManufacturingBatchById(idUser, id, isDeleted) {
    return api.get(
      UtilsUrl.ManufacturingBatchURL() +
        "/deleteManufacturingBatchById/" +
        idUser +
        "/" +
        id +
        "/" +
        isDeleted
    );
  }
  getManufacturingBatchByIdUser(idUserCreation, isDeleted) {
    return api.get(
      UtilsUrl.ManufacturingBatchURL() +
        "/getManufacturingBatchByIdUser/" +
        idUserCreation +
        "/" +
        isDeleted
    );
  }
  getManufacturingBatchBySerialNumber(idUserCreation, isDeleted, serialNumber) {
    return api.get(
      UtilsUrl.ManufacturingBatchURL() +
        "/getManufacturingBatchBySerialNumber/" +
        idUserCreation +
        "/" +
        isDeleted +
        "/" +
        serialNumber
    );
  }
  //   getAllSkuCategory(idUserCreation, isDeleted) {
  //     return api.get(
  //       UtilsUrl.productURL() +
  //         "/getAllSKUCategory/" +
  //         idUserCreation +
  //         "/" +
  //         isDeleted
  //     );
  //   }
  //   getAllCategoriesBySubFamilyId(idUserCreation, subFamilyId) {
  //     return api.get(
  //       UtilsUrl.productURL() +
  //         "/getCategoryBySubFamilyId/" +
  //         idUserCreation +
  //         "/" +
  //         subFamilyId
  //     );
  //   }
  //   getAllProductsByFilters(filterModel) {
  //     return api.get(
  //       UtilsUrl.productURL() +
  //         "/getAllProductsByFilters/" +
  //         filterModel.idUser +
  //         "/" +
  //         filterModel.isDeleted +
  //         "/" +
  //         filterModel.brandId +
  //         "/" +
  //         filterModel.categoryId +
  //         "/" +
  //         filterModel.dateDebut +
  //         "/" +
  //         filterModel.dateFin +
  //         "/" +
  //         filterModel.codearticle
  //     );
  //   }
  //   getProductById(idUser, id) {
  //     return api.get(
  //       UtilsUrl.productURL() + "/getProductById/" + idUser + "/" + id
  //     );
  //   }
  //   addProductSubFamily(productSubFamilyModel) {
  //     return api.post(
  //       UtilsUrl.productURL() + "/addProductSubFamily",
  //       productSubFamilyModel
  //     );
  //   }

  //   addProductFamily(productModel) {
  //     return api.post(UtilsUrl.productURL() + "/addProductFamily", productModel);
  //   }
  //   addProductCategory(prodCategoryModel) {
  //     return api.post(
  //       UtilsUrl.productURL() + "/addProductCategory",
  //       prodCategoryModel
  //     );
  //   }
}

export default new ManufacturingBatchService();
